import { AreaApi } from "@unit/apis";
import { useAtom } from "jotai";
import { useCallback, useMemo } from "react";

import { useAppSnackbar } from "@/custom-hooks/use-app-snackbar";
import { API_URL } from "@/global-state/firebase-settings";
import { areasAtom, idTokenAtom, loadingAtom } from "@/global-state/jotai-atom";

export const useAreaApi = () => {
  const { setAppSnackbar } = useAppSnackbar();
  const [, setLoading] = useAtom(loadingAtom);
  const [, setAreas] = useAtom(areasAtom);
  const [idToken] = useAtom(idTokenAtom);
  const StoreAreaApi = useMemo(() => new AreaApi(API_URL, idToken), [idToken]);

  const getAreaList = useCallback(async () => {
    await setLoading(true);
    try {
      const result = await StoreAreaApi.getAreaList({});
      return setAreas(result.objects);
    } catch (e: any) {
      setAppSnackbar(e?.response?.data?.message || e?.response?.data?.devMessage || "", {
        error: true,
      });
      throw e;
    } finally {
      await setLoading(false);
    }
  }, [StoreAreaApi]);

  return {
    getAreaList,
  };
};
